import type { PipelinePlaceView } from '../../lib/client.ts';
import { usePipelines } from '../../lib/record-data.ts';
import { StageStepper } from '../pipelines/stage-control.tsx';

/**
 * A deal's or job's places in its type's EXTRA pipelines (TS-1956), one compact stepper each under
 * the default one in the card header. The default place is the card's own status stepper, so it is
 * left out here; an archived place is not drawn. A move is the same `:move-status` call: the API
 * resolves the stage's pipeline and moves only that place.
 */
export function RecordPlaces({
  type,
  places,
  disabled,
  onMove,
}: {
  type: 'deal' | 'job';
  places: readonly PipelinePlaceView[];
  disabled?: boolean | undefined;
  onMove: (stageId: string) => void;
}) {
  const pipelines = usePipelines(type);
  const extra = places.filter((p) => !p.isDefault && !p.archivedAt);
  return (
    <>
      {extra.map((place) => {
        const pipeline = pipelines.find((p) => p.id === place.pipelineId);
        if (!pipeline) return null;
        return (
          <StageStepper
            key={place.pipelineId}
            size="compact"
            pipeline={pipeline}
            value={place.stageId}
            previousStageId={place.previousStageId}
            disabled={disabled}
            onMove={onMove}
          />
        );
      })}
    </>
  );
}
